(function () {
  function updateProductionStepsHeight() {
    const section = document.querySelector('.section-production-steps');
    if (!section) return;

    const headerEl = document.querySelector('#header');
    if (!headerEl) return;

    const headerSection = headerEl.closest('[id^="shopify-section-"]');
    if (!headerSection) return;

    let styleEl = document.querySelector('#ps-header-offset');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'ps-header-offset';
      document.head.appendChild(styleEl);
    }

    // Check if production-steps comes before the header in the DOM
    const isBeforeHeader = !!(section.compareDocumentPosition(headerSection) & Node.DOCUMENT_POSITION_FOLLOWING);

    if (!isBeforeHeader) {
      // Production-steps is after header: stick below header, no header offset needed
      document.documentElement.style.setProperty('--production-steps-height', '0px');
      styleEl.textContent = '#' + section.id + ' { top: calc(var(--header-height) - 1px) !important; }';
      return;
    }

    const innerDiv = section.querySelector('[data-sticky]');
    const isSticky = innerDiv?.dataset.sticky === 'true';
    const height = isSticky ? section.offsetHeight : 0;

    document.documentElement.style.setProperty('--production-steps-height', height + 'px');

    if (isSticky && height > 0) {
      styleEl.textContent = '#' + headerSection.id + ' { inset-block-start: ' + (height - 1) + 'px !important; }';
    } else {
      styleEl.textContent = '';
    }
  }

  function initSmoothScroll() {
    const link = document.querySelector('a.production-steps-section');
    if (!link) return;
    link.addEventListener('click', function (e) {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateProductionStepsHeight();
    initSmoothScroll();
  });
  window.addEventListener('resize', updateProductionStepsHeight);
  window.addEventListener('shopify:section:load', updateProductionStepsHeight);
  window.addEventListener('shopify:section:select', updateProductionStepsHeight);
})();
